function Underline() {
  return (
    <div className="my-[6rem]">
      <div
        data-aos="zoom-out-up"
        data-aos-offset="100"
        data-aos-duration="200"
        className="w-8 h-4 bg-[#167469] mx-auto translate-y-2 rounded-t-full"
      ></div>
      <p
        data-aos="zoom-out-up"
        data-aos-offset="100"
        data-aos-duration="300"
        className="max-w-[36rem] min-w-min w-[12rem] xss:w-[20rem] sm:w-[36rem] mx-auto border border-[#46AEA2] "
      ></p>
      <div
        data-aos="zoom-out-up"
        data-aos-offset="100"
        data-aos-duration="350"
        className="w-8 h-4 bg-[#46AEA2] mx-auto translate-y-2 rounded-b-full"
      ></div>
    </div>
  );
}

export default Underline;
